import React, { useState, useEffect } from 'react';
import { XCircle } from 'lucide-react';
import api from '../../utils/axios';

const LeadModal = ({ isModalOpen, setIsModalOpen, handleAddLead, newLead, setNewLead }) => {
  const [colleges, setColleges] = useState([]);
  const [availablePrograms, setAvailablePrograms] = useState([]);

  const fetchColleges = React.useCallback(async () => {
    try {
      const res = await api.get('/colleges/active');
      const activeColleges = res.data.data;
      setColleges(activeColleges);
      
      if (activeColleges.length > 0 && !newLead.college) {
        const firstCollege = activeColleges[0];
        setNewLead(prev => ({ 
          ...prev, 
          college: firstCollege.name,
          program: firstCollege.programs && firstCollege.programs.length > 0 ? firstCollege.programs[0] : firstCollege.name
        }));
        setAvailablePrograms(firstCollege.programs || []);
      }
    } catch (err) {
      console.error('Failed to fetch colleges', err);
    }
  }, [newLead.college, setNewLead]);

  useEffect(() => {
    if (isModalOpen) {
      fetchColleges();
    }
  }, [isModalOpen, fetchColleges]);

  const handleCollegeChange = (e) => {
    const collegeName = e.target.value;
    const selectedCollege = colleges.find(c => c.name === collegeName);
    
    const programs = selectedCollege?.programs || [];
    setAvailablePrograms(programs);
    setNewLead({
        ...newLead,
        college: collegeName,
        program: programs.length > 0 ? programs[0] : collegeName
    });
  };

  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}></div>
      <div className="bg-white max-w-md w-full rounded-sm shadow-2xl relative z-10 animate-scaleIn">
        <div className="bg-[#cc0000] p-6 text-white flex justify-between items-center">
          <h3 className="text-xl font-black uppercase tracking-widest">Manual Entry</h3>
          <button onClick={() => setIsModalOpen(false)}><XCircle size={24} /></button>
        </div>
        <form onSubmit={handleAddLead} className="p-8 space-y-6">
          <div>
            <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Student Name</label>
            <input type="text" required className="w-full border-b-2 border-slate-100 py-2 outline-none focus:border-[#cc0000] font-bold text-sm" value={newLead.name} onChange={e => setNewLead({...newLead, name: e.target.value})} />
          </div>
          <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Email Address</label>
                <input type="email" required className="w-full border-b-2 border-slate-100 py-2 outline-none focus:border-[#cc0000] font-bold text-sm" value={newLead.email} onChange={e => setNewLead({...newLead, email: e.target.value})} />
              </div>
              <div>
                <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Phone Number</label>
                <input type="tel" required className="w-full border-b-2 border-slate-100 py-2 outline-none focus:border-[#cc0000] font-bold text-sm" value={newLead.phone} onChange={e => setNewLead({...newLead, phone: e.target.value})} />
              </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Select College</label>
                <select 
                  className="w-full border-b-2 border-slate-100 py-2 outline-none focus:border-[#cc0000] font-bold text-sm bg-transparent" 
                  value={newLead.college} 
                  onChange={handleCollegeChange}
                >
                  {colleges.length > 0 ? (
                    colleges.map((c, idx) => (
                      <option key={idx} value={c.name}>{c.name}</option>
                    ))
                  ) : (
                    <option value="">No Colleges</option>
                  )}
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Select Program</label>
                <select 
                  className="w-full border-b-2 border-slate-100 py-2 outline-none focus:border-[#cc0000] font-bold text-sm bg-transparent" 
                  value={newLead.program} 
                  onChange={e => setNewLead({...newLead, program: e.target.value})}
                >
                  {availablePrograms.length > 0 ? (
                    availablePrograms.map((p, idx) => (
                      <option key={idx} value={p}>{p}</option>
                    ))
                  ) : (
                    <option value={newLead.college}>{newLead.college || 'N/A'}</option>
                  )}
                </select>
              </div>
          </div>
          <div>
            <label className="block text-[10px] font-black uppercase text-slate-500 mb-2">Message / Note</label>
            <textarea className="w-full border border-slate-100 p-2 outline-none focus:border-[#cc0000] font-bold text-sm resize-none" rows="3" value={newLead.message || ''} onChange={e => setNewLead({...newLead, message: e.target.value})} placeholder="Additional details..."></textarea>
          </div>
          <button type="submit" className="w-full bg-slate-900 text-white py-4 font-black uppercase text-xs tracking-widest hover:bg-[#cc0000] transition-all shadow-xl">Submit Lead</button>
        </form>
      </div>
    </div>
  );
};

export default LeadModal;
